import { LogIn, User } from "react-feather";
import { Link, useNavigate } from "react-router-dom";

import man from "assets/images/user/user.png";
import { Image, LI, P, UL } from "../../../AbstractElements";
import { LogOut } from "../../../Constant";
import { useUserProfile } from "hook/useUserProfile";
import axiosInstance from "hook/axiosInstance";
const UserHeader = () => {
  const history = useNavigate();

  const { data } = useUserProfile();

  const Logout = async () => {
    await axiosInstance.post("/api/User/logout");
    localStorage.clear();
    history(`${process.env.PUBLIC_URL}/login`);
  };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <Image
          attrImage={{
            className: "b-r-10 m-0",
            src: man,
            alt: "",
          }}
        />
        <div className="media-body">
          <span>{data?.displayName}</span>
          <P attrPara={{ className: "mb-0 font-roboto" }}>
            {data?.userRole?.displayName}{" "}
            <i className="middle fa fa-angle-down"></i>
          </P>
        </div>
      </div>
      <UL
        attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}
      >
        <Link to={"/user/current"}>
          <LI>
            <User />
            <span>Thông tin </span>
          </LI>
        </Link>
        <Link to={"/user/change-password"}>
          <LI>
            <User />
            <span>Đổi mật khẩu </span>
          </LI>
        </Link>
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
